(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-image-product"] && !Shopify.designMode) return;
  try {
    
$(function() {
  $(document).on('shopify:section:load', function(e){
    let section__id = e.originalEvent.detail.sectionId;

    if ($(".related__product_wrapper3__"+section__id+"").hasClass("slick-slide")){
      $(".related__product_wrapper3__"+section__id+"").slick('unslick');
    }

    $(".related__product_wrapper3__"+section__id+"").slick({
     dots: true,
     dotsClass: 'custom-dots',
     infinite: true,
     speed: 300,
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows : false,
      prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve" ><g transform="matrix(-1 1.22465e-16 -1.22465e-16 -1 443.52 443.52)"><g><path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734    L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8    C342.889,227.058,342.889,216.255,336.226,209.591z" data-original="#000000" class="active-path" fill="#000000"/></svg></button>',
     nextArrow:'<button type="button" class="slick-next pull-right"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"><path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8C342.889,227.058,342.889,216.255,336.226,209.591z"/></svg></button>',
     responsive: [
       {
         breakpoint: 1025,
         settings: {
          arrows : true,
           slidesToShow: 1,
           slidesToScroll: 1,
         }
       },
       {
         breakpoint: 600,
         settings: {
           arrows : true,
           slidesToShow: 1,
           slidesToScroll: 1,
         }
       }
     ]
    })
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-image-with-carousel"] && !Shopify.designMode) return;
  try {
    
$(function() {
  $(document).on('shopify:section:load', function(e){
    let section__id = e.originalEvent.detail.sectionId;

	  if ($("#slick__slider_"+section__id+"").hasClass("slick-slide")){
      $("#slick__slider_"+section__id+"").slick('unslick');
    }

    //$("#slick__slider_"+section__id+"").slick({
    //    dots: true,
    //    dotsClass: 'custom-dots',
    //    infinite: true,
    //    autoplay: true,
    //    autoplaySpeed: 3000,
    //    adaptiveHeight: true,
    //    slidesToShow: 1,
    //    slidesToScroll: 1,
    //    fade: true,
    //    cssEase: 'linear',
    //    prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve" ><g transform="matrix(-1 1.22465e-16 -1.22465e-16 -1 443.52 443.52)"><g><path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734    L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8    C342.889,227.058,342.889,216.255,336.226,209.591z" data-original="#000000" class="active-path" fill="#000000"/></svg></button>',
    //    nextArrow:'<button type="button" class="slick-next pull-right"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"><path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8C342.889,227.058,342.889,216.255,336.226,209.591z"/></svg></button>',
    //  });
  });

  $(document).on('shopify:block:select', function(e){
    let section__id = e.originalEvent.detail.sectionId;
    let block__id = e.originalEvent.detail.blockId;
	let slicknumber = $(".block__"+block__id+"").attr("data-slick-index");
    $("#slick__slider_"+section__id+"").slick('slickGoTo', slicknumber);
    $("#slick__slider_"+section__id+"").slick('slickSetOption', {'autoplay': false}, true);

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-collection1"] && !Shopify.designMode) return;
  try {
    
$(function() {
  $(document).on('shopify:section:load', function(e){
    let section__id = e.originalEvent.detail.sectionId;

    if ($(".related__product_wrapper__"+section__id+"").hasClass("slick-slide")){
      $(".related__product_wrapper__"+section__id+"").slick('unslick');
    }

    $(".related__product_wrapper__"+section__id+"").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 2,
       prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve" ><g transform="matrix(-1 1.22465e-16 -1.22465e-16 -1 443.52 443.52)"><g><path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734    L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8    C342.889,227.058,342.889,216.255,336.226,209.591z" data-original="#000000" class="active-path" fill="#000000"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"><path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8C342.889,227.058,342.889,216.255,336.226,209.591z"/></svg></button>',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
           centerMode: true,
            centerPadding: '150px',
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }
      ]
    })
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-collection2"] && !Shopify.designMode) return;
  try {
    
$(function() {
  $(document).on('shopify:section:load', function(e){
    let section__id = e.originalEvent.detail.sectionId;

    if ($(".related__product_wrapper2__"+section__id+"").hasClass("slick-slide")){
      $(".related__product_wrapper2__"+section__id+"").slick('unslick');
    }

    $(".related__product_wrapper2__"+section__id+"").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 2,
       prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve" ><g transform="matrix(-1 1.22465e-16 -1.22465e-16 -1 443.52 443.52)"><g><path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734    L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8    C342.889,227.058,342.889,216.255,336.226,209.591z" data-original="#000000" class="active-path" fill="#000000"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"><path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8C342.889,227.058,342.889,216.255,336.226,209.591z"/></svg></button>',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            centerMode: true,
            centerPadding: '300px',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            centerMode: true,
            centerPadding: '100px',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    })
  });
});

  } catch(e) { console.error(e); }
})();
})();
